import { useState } from "react";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import CompanyBankAccountMainPage from "./CompanyBankAccountMainPage";
import PartyBankAccountMainPage from "./PartyBankAccountMainPage";
import AuthorizationService from "../../service/authorization-service";

const authorizationService = new AuthorizationService();

await loadDictionary("bank-account-main-page");

function BankAccountMainPage() {
  const [activeTab, setActiveTab] = useState('company');
  
  return (
    <div className="page">
      <div className="page-header bg-body p-3 pb-0">
        <h4 className="page-title pb-3">{i18n.t("bank-account-main-page.page_title")}</h4>
        <div className="header-content">
          <ul className="nav nav-underline">
            <li className="nav-item">
              <a href="#" className={"nav-link link-dark " + (activeTab === "company" ? "active" : "")} onClick={() => setActiveTab('company')}>{i18n.t("bank-account-main-page.company_tab")}</a>
            </li>
            <li className={"nav-item " + (authorizationService.cannot('bank_account_parties_list_page') ? 'd-none' : '')}>
              <a href="#" className={"nav-link link-dark " + (activeTab === "party" ? "active" : "")} onClick={() => setActiveTab('party')}>{i18n.t("bank-account-main-page.party_tab")}</a>
            </li>
          </ul>
        </div>
      </div>
      {activeTab === 'company' ? <CompanyBankAccountMainPage /> : <PartyBankAccountMainPage />}
    </div>
  );
}

export default BankAccountMainPage;